import { useCallback, useMemo } from 'react';

import type { Group } from '@bugbug/core/types/groups';
import { useCheckedSteps } from '~/modules/uiState/hooks/useCheckedSteps';
import { ACTIONS } from '~/services/toasts/internalServerError';

import { testsApi } from '../../tests.api';
import { showGroupError } from '../../tests.utils';
import { useCleanupAfterTestPartialsDelete } from '../useCleanupAfterTestPartialsDelete/useCleanupAfterTestPartialsDelete';

export const useDeleteGroup = () => {
  const [deleteGroup, deleteGroupState] = testsApi.useDeleteGroupMutation();
  const cleanUpAfterDelete = useCleanupAfterTestPartialsDelete();
  const { setCheckedGroup } = useCheckedSteps();

  const handleDeleteGroup = useCallback(
    async ({ id }: { id: Group['id'] }): Promise<void> => {
      const result = deleteGroup({ id }).unwrap();

      result
        .then(() => {
          setCheckedGroup({ groupId: id, checked: false });
          cleanUpAfterDelete({ stepsIds: [], groupsIds: [id] });
        })
        .catch((error) => {
          showGroupError(ACTIONS.DELETE, error);
        });

      return result;
    },
    [cleanUpAfterDelete, deleteGroup, setCheckedGroup],
  );

  return useMemo(
    () => [handleDeleteGroup, deleteGroupState] as const,
    [handleDeleteGroup, deleteGroupState],
  );
};
